import { ReactNode, PropsWithChildren } from "react";
import styled from "@emotion/styled/macro";
import {
  tokens,
  Typography,
  LoadingIndicator,
} from "@sunrun/experience-ui-components";

type ConfirmInfoTaskCardProps = {
  taskHeader?: string;
  subHeader?: string;
  taskAction?: ReactNode;
  loading?: boolean;
};

const ConfirmInfoTaskCard = ({
  taskHeader,
  subHeader,
  taskAction,
  children,
  loading = false,
}: PropsWithChildren<ConfirmInfoTaskCardProps>) => {
  return (
    <CardContainer className="flex flex-col gap-4">
      <CardDotContainer>
        <CardDot></CardDot>
      </CardDotContainer>
      <CardBody>
        <CardHeader>
          <CardHeaderText>
            <Typography
              fontWeight="bold"
              size={18}
              color={tokens.BRAND_HERO_BLUE}
            >
              {taskHeader}
            </Typography>
            {subHeader && (
              <Typography
                size={14}
                color={tokens.BRAND_HERO_BLUE}
                style={{ marginTop: "8px" }}
              >
                {subHeader}
              </Typography>
            )}
          </CardHeaderText>
          {!loading && taskAction}
        </CardHeader>
        <CardContent>
          {loading ? (
            <StyledLoadingIndicator color="black" height={48} width={48} />
          ) : (
            children
          )}
        </CardContent>
      </CardBody>
    </CardContainer>
  );
};

const StyledLoadingIndicator = styled(LoadingIndicator)`
  margin: 48px;
`;

const CardContainer = styled.div`
  display: flex;
  flex-direction: row;
  border: 1px solid #e0e0e0;
  border-radius: 16px;
  background: ${tokens.OFFWHITE_70};
  padding: 16px;
  min-width: 400px;
  gap: 12px;
`;

const CardDotContainer = styled.div``;

const CardDot = styled.div`
  width: 16px;
  height: 32px;
  background-color: ${tokens.BRAND_MEDIUMBLUE};
  border-radius: 4px;
  margin-bottom: auto;
`;

const CardBody = styled.div`
  flex: 1;
`;

const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
`;

const CardHeaderText = styled.div`
  font-size: 16px;
  font-weight: 600;
`;

const CardContent = styled.div`
  margin-top: 8px;
`;

export { ConfirmInfoTaskCard };
